<template>
  <component :is="tag" :class="className">
    <slot></slot>
  </component>
</template>

<script>
/**
 * @class Card
 *
 * @description this component is a wrapper for bootstrap "panel"
 */
export default {
  name: 'Card',
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    className: {
      type: String,
      default: 'panel',
    },
  },
}
</script>
